import { defineMessages } from 'react-intl';

export default defineMessages({
    searchForDirector: {
        id: 'searchForDirector',
        defaultMessage: 'Enter your name as it appears on Companies House'
    },
    continueWithName: {
        id: 'continueWithName',
        defaultMessage: 'Continue with "{fullName}"'
    }
});
